import * as Sentry from "@sentry/react";
import React from "react";

import PageTitle from "../../../../components/PageTitle";
import SurveyAuthoringBase from "./SurveyAuthoringBase";

import { getFeatureFlagQuery } from "../../../../hooks/useFeatureFlag";

// import Survey from "./Survey";
import { currentUserQuery } from "../../../../api/queries";
import { SimplifiedQuery, dataLoader } from "../../../../api/queries/dataLoader";

// Data loader function
export const surveyLoader = () => {
	const queries: (() => SimplifiedQuery)[] = [getFeatureFlagQuery];

	return dataLoader([[currentUserQuery], queries]);
};

const SurveyPage = () => {
	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<PageTitle title="Survey Authoring" />
			<SurveyAuthoringBase />
		</Sentry.ErrorBoundary>
	);
};

export default SurveyPage;
